export let messageListAriaLabel = "EmU0Xc";
export let noMoreRowsMessageBarTitle = "xzP_8";
export let noMoreRowsText = "MrAWEe";
export let noMoreRowsSettingButtonText = "SoZqHc";
export default {messageListAriaLabel,noMoreRowsMessageBarTitle,noMoreRowsText,noMoreRowsSettingButtonText};